const CheckboxCheckSvg = () => {
  return (
    <svg width="0.875rem" height="0.875rem" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="14" height="14" rx="4" stroke="#333333" strokeWidth="1.5" />
      <path d="M3.8 8.3 L6.5 11.2 L12 6" stroke="#333333" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CheckboxCheckSvg;
